import { List, Record } from "immutable";

import { IntegrationActorModel } from "./IntegrationActorModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";
import { TicketModel } from "./TicketModel";

export type TTicketPermissionStatus = "failed" | "granted" | "pending" | "revoked";
type TTicketPermissionType = "prerequisite" | "regular";

const defaults = {
  expiresAt: null as Date | null,
  grantedAt: null as Date | null,
  id: "",
  integrationActor: null as IntegrationActorModel | null,
  integrationResourceRole: null as IntegrationResourceRoleModel | null,
  oldIntegrationResourceRole: null as IntegrationResourceRoleModel | null,
  status: "" as TTicketPermissionStatus,
  ticket: null as null | TicketModel,
  ticketTargetIds: List<string>(),
  type: "" as TTicketPermissionType,
  virtualRole: null as IntegrationResourceRoleModel | null,
  virtualRoleId: null as null | string,
};

export class TicketPermissionModel extends Record<typeof defaults>(defaults) {
  get role() {
    return this.virtualRole || this.integrationResourceRole;
  }

  static fromServerData(data: unknown) {
    const {
      expiresAt,
      grantedAt,
      id,
      integrationActor,
      integrationResourceRole,
      oldIntegrationResourceRole,
      status,
      ticket,
      ticketTargetIds,
      type,
      virtualRole,
      virtualRoleId,
    } = data as typeof defaults;

    return new TicketPermissionModel({
      expiresAt: expiresAt ? new Date(expiresAt) : null,
      grantedAt: grantedAt ? new Date(grantedAt) : null,
      id,
      integrationActor: integrationActor ? IntegrationActorModel.fromServerData(integrationActor) : null,
      integrationResourceRole: integrationResourceRole
        ? IntegrationResourceRoleModel.fromServerData(integrationResourceRole)
        : null,
      oldIntegrationResourceRole: oldIntegrationResourceRole
        ? IntegrationResourceRoleModel.fromServerData(oldIntegrationResourceRole)
        : null,
      status,
      ticket: ticket ? TicketModel.fromServerData(ticket) : null,
      ticketTargetIds: List(ticketTargetIds) ?? List(),
      type,
      virtualRole: virtualRole ? IntegrationResourceRoleModel.fromServerData(virtualRole) : null,
      virtualRoleId,
    });
  }
}
